// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae825b08","239":"d1f7a7e9","732":"4753c6aa"}[chunkId] + ".chunk.js";
};